// The next thing the rider must do: once the pickup is set (and, at an airport, the terminal), "Where to?" is the next step until it is filled.
export function isWhereNext({ hourly, pickup, dropoff, pickupAirport, terminal }) {
  if (hourly) return false;                                   // a by-the-hour ride has no drop-off
  if (!pickup || pickup.lat == null) return false;
  if (dropoff && (dropoff.lat != null || (dropoff.address || '').trim())) return false;
  if (pickupAirport && !terminal) return false;               // the airport details come first
  return true;
}
